module.exports = __webpack_public_path__ + "img/bowen7.eeb0808a.png";